import { styled } from "../../Theme";

export const NavBarItemContainer = styled.div`
  display: flex;
  height: 100%;
  min-width: 8em;
  width: 100%;
  justify-content: space-evenly;
`;

interface TitleProps {
  selected?: boolean;
}

export const NavBarItemTitle = styled.button<TitleProps>`
  text-align: center;
  width: 100%;
  height: 100%;
  align-self: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: "Title";
  user-select: none;
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
  background-color: ${(props) => (props.selected ? props.theme.color.secondary : "transparent")};
  color: ${(props) => props.theme.color.lightText};
  font-size: 1.5em;
  cursor: pointer;

  @media (max-width: 768px) {
    color: white;
    font-size: 2em;
  }

  :hover {
    background-color: ${(props) => props.theme.color.secondary};
  }
`;
